import { ProductSource } from '../_models/enum/product-source';
import { OrganizationCustomerConfiguration } from '../_models/class/organization';

/** Fold percentage discounts: 1 - (1-p1)*(1-p2)*… (matches API `Discount::stack_percentages`). */
export function combinedDiscountPercent(percents: number[]): number {
  if (percents.length === 0) {
    return 0;
  }
  let remaining = 1;
  for (const percent of percents) {
    const p = percent > 1 ? percent / 100 : percent;
    remaining *= 1 - p;
  }
  return 1 - remaining;
}

/** Codes from `discounts`, plus legacy `discount` when not already listed (case-insensitive). */
export function organizationCustomerDiscountCodes(customer: OrganizationCustomerConfiguration | undefined): string[] {
  if (!customer) {
    return [];
  }
  return customer.discountCodes();
}

export function organizationCustomerAllowsPurchase(
  customer: OrganizationCustomerConfiguration | undefined,
  source: ProductSource,
): boolean {
  if (!customer) {
    return true;
  }
  return customer.allowsPurchase(source);
}

/** Issuing org ids to try when validating `capabilities.customer.discounts` codes. */
export function organizationCustomerDiscountValidationOrganizationIds(
  customer: OrganizationCustomerConfiguration | undefined,
  marketOrganizationId?: string,
): string[] {
  const ids: string[] = [];
  if (marketOrganizationId) {
    ids.push(marketOrganizationId);
  }
  if (!customer) {
    return ids;
  }
  if (customer.resellerOrganizationId) {
    ids.push(customer.resellerOrganizationId);
  }
  for (const alias of customer.customerAliasIds ?? []) {
    ids.push(alias.organizationId);
  }
  return [...new Set(ids)];
}
